import React from "react";
import { ANDROID_URL, IOS_URL } from "../lib/appLinks";

const AppleIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.564 12.727c-.03-3.043 2.48-4.503 2.593-4.573-1.412-2.065-3.607-2.348-4.387-2.38-1.868-.19-3.646 1.098-4.593 1.098-.943 0-2.405-1.07-3.955-1.04-2.036.03-3.91 1.183-4.957 3.007-2.113 3.663-.54 9.085 1.51 12.06 1.003 1.457 2.198 3.093 3.766 3.035 1.51-.06 2.08-.977 3.905-.977 1.826 0 2.34.977 3.938.945 1.625-.03 2.654-1.487 3.65-2.948 1.15-1.693 1.622-3.33 1.65-3.414-.036-.016-3.167-1.216-3.198-4.82Zm-3.02-8.86C15.39 2.86 15.96 1.49 15.81.12c-1.176.048-2.6.783-3.44 1.79-.75.89-1.41 2.31-1.234 3.67 1.31.102 2.65-.666 3.4-1.712Z" />
  </svg>
);

const PlayIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path d="M3.6 2.3c-.3.3-.5.7-.5 1.3v16.8c0 .6.2 1 .5 1.3l.1.1L13 12.6v-.2L3.7 2.2l-.1.1Z" fill="#00D2FF" />
    <path d="m16.7 9.3-3.2-1.9-2.5 2.5 2.5 2.5 3.3-1.9c.9-.5.9-1.7-.1-1.3Z" fill="#FFCE00" />
    <path d="M13.5 12.6 4 22.1c.4.4 1 .4 1.7 0l10.9-6.2-3.1-3.3Z" fill="#ED3241" />
    <path d="M13.5 11.4 16.6 8 5.7 1.9C5 1.5 4.4 1.5 4 1.9l9.5 9.5Z" fill="#00E676" />
  </svg>
);

export default function AppBadges({ className = "" }) {
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      <a
        href={ANDROID_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="android-download-btn"
        className="inline-flex items-center gap-3 rounded-xl bg-navy-dark text-sand pl-4 pr-6 py-3 ring-1 ring-white/15 transition-transform duration-300 hover:scale-105"
      >
        <PlayIcon className="h-7 w-7" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] tracking-wide uppercase text-sand/60">Get it on</span>
          <span className="block text-base font-semibold -mt-0.5">Google Play</span>
        </span>
      </a>
      <a
        href={IOS_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="ios-download-btn"
        className="inline-flex items-center gap-3 rounded-xl bg-navy-dark text-sand pl-4 pr-6 py-3 ring-1 ring-white/15 transition-transform duration-300 hover:scale-105"
      >
        <AppleIcon className="h-7 w-7 text-sand" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] tracking-wide uppercase text-sand/60">Download on the</span>
          <span className="block text-base font-semibold -mt-0.5">App Store</span>
        </span>
      </a>
    </div>
  );
}
